const icons = {};
icons.block = <svg width="20px" height="20px" viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg' fillRule='evenodd'
clipRule='evenodd' strokeLinejoin='round' strokeMiterlimit='1.414'>
    <g fill='#0058b0' fillRule='nonzero'>
        <path d='M45.013,46.298c0.705,0 1.285,-0.58 1.285,-1.285l0,-42.026c0,-0.705 -0.58,-1.285 -1.285,-1.285l-42.026,0c-0.705,0 -1.285,0.58 -1.285,1.285l0,42.026c0,0.705 0.58,1.285 1.285,1.285l42.026,0Zm-40.741,-42.026l39.456,0l0,39.456l-39.456,0l0,-39.456Z'
        />
        <path d='M11.221,8.736l7.36,0l0,12.117l10.838,0l0,-12.117l7.361,0l0,30.518l-7.361,0l0,-12.743l-10.838,0l0,12.743l-7.36,0l0,-30.518Z'
        />
    </g>
</svg>;
export default icons;
